import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeHtmlTags'
})
export class RemoveHtmlTagsPipe implements PipeTransform {

  private regex = /(<\s*([a-zA-Z]+)\s*([a-zA-Z=\\"-\s]*)>)|(<\/([a-zA-Z]+)\s*>)/g;

  transform(value: string): string {
    if (value !== null && value !== undefined) {
        while(value.match(this.regex)) {
            value = value.replace(this.regex, "");
        }
    }
    return value;
  }
}
